<template lang="pug">
  #app
    Main
</template>

<script>
import Main from "./components/Main.vue";

export default {
  name: "app",
  components: {
    Main
  }
};
</script>

<style>
html {
  background: radial-gradient(
    rgba(22, 22, 26, 0) 40%,
    rgba(22, 22, 26, 0.1) 70%,
    rgba(22, 22, 26, 0.3) 100%
  );
  background-color: #252525;
}
#app {
  font-family: Inter, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #f7f8f8;
  margin-top: 60px;
}
</style>
